import React, { useState } from "react";
import { StyledBannerTitle } from "./styles";
import { GlobalYScrollListener } from "../../hooks/useWindowEvent";
const BannerTitle = ({ children, theme }) => {
  const [fireAnimation, setFireAnimation] = useState(false);
  GlobalYScrollListener({ setter: setFireAnimation });
  return (
    <StyledBannerTitle fireAnimation={fireAnimation} theme={theme}>
      {children}
    </StyledBannerTitle>
  );
};

export default BannerTitle;
